import { createFileRoute } from '@tanstack/react-router'

import { AppSidebarContainer } from '@/components/app/app-sidebar-container'
import { MillsheetDuplicatesContainer } from '@/components/screens/millsheet/duplicates/millsheet-duplicates-container'

export const Route = createFileRoute('/t/$tenant_id/millsheets/duplicates')({
  component: MillsheetDuplicatesPage,
})

// route はレイアウト（サイドバー + メイン領域）だけを組み、データ取得・ミューテーション配線は
// MillsheetDuplicatesContainer に委譲する（ミルシート一覧 route と同じ分担）
function MillsheetDuplicatesPage() {
  const { tenant_id: tenantId } = Route.useParams()
  return (
    <div className="flex min-h-screen">
      <AppSidebarContainer tenantId={tenantId} />
      <main className="min-w-0 flex-1">
        <MillsheetDuplicatesContainer tenantId={tenantId} />
      </main>
    </div>
  )
}
